import type { IPlainTooltipProps } from "@similarweb/ui-components";
import InteractiveTooltip from "app/components/React/Tooltip/InteractiveTooltip/InteractiveTooltip";
import styled from "styled-components";

export const StyledSignalsTooltip = styled(InteractiveTooltip)<IPlainTooltipProps>`
    &.PlainTooltip-element {
        min-width: 200px;
        background-color: transparent;
        border-radius: 20px;
        box-shadow: 0 0 20px 0 rgba(14, 30, 62, 0.22);
    }

    &.PlainTooltip-element-white.right:before {
        border-right-color: transparent;
    }

    &.PlainTooltip-element-white.left:before {
        border-left-color: transparent;
    }

    &.PlainTooltip-content {
        padding: 0;
        border-radius: 20px;
    }
`;

export const StyledTooltipTrigger = styled.div`
    width: 100%;
    height: 100%;
`;
